import React from 'react';

// Loading spinner with an optional label.
export default function Spinner({ label = 'Nalaganje …' }) {
  return (
    <div className="spinner-row">
      <span className="spinner" />
      {label ? <span>{label}</span> : null}
    </div>
  );
}
